export const GET_GAMES_SUCCESS = 'GET_GAMES_SUCCESS';
export const GET_GAMES_FAILURE = 'GET_GAMES_FAILURE';

export const GET_ENTRIES_SUCCESS = 'GET_ENTRIES_SUCCESS';
export const GET_ENTRIES_FAILURE = 'GET_ENTRIES_FAILURE';

export const GET_EVENT_SUCCESS = 'GET_EVENT_SUCCESS';
export const GET_EVENT_FAILURE = 'GET_EVENT_FAILURE';
export const GET_EVENTS_SUCCESS = 'GET_EVENTS_SUCCESS';
export const GET_EVENTS_FAILURE = 'GET_EVENTS_FAILURE';
export const CLEAR_EVENTS = 'CLEAR_EVENTS';

export const GET_BONUSES_SUCCESS = 'GET_BONUSES_SUCCESS';
export const GET_BONUSES_FAILURE = 'GET_BONUSES_FAILURE';

export const POST_ENTRY_FAILURE = 'POST_ENTRY_FAILURE';

export const PUT_TEAM_MEMBER_SUCCESS = 'PUT_TEAM_MEMBER_SUCCESS';
export const PUT_TEAM_MEMBER_FAILURE = 'PUT_TEAM_MEMBER_FAILURE';

export const SET_ENTRY = 'SET_ENTRY';
export const SET_SELECTED_GAME_ID = 'SET_SELECTED_GAME_ID';
export const SET_SELECTED_GAME_ID_SUCCESS = 'SET_SELECTED_GAME_ID_SUCCESS';

export const SET_REVEAL_ANIMATION_PROGRESS = 'SET_REVEAL_ANIMATION_PROGRESS';

export const SET_PRIZE_SUCCESS = 'SET_PRIZE_SUCCESS';
export const SET_PRIZE_FAILURE = 'SET_PRIZE_FAILURE';

export const SET_LOADING_DATA_FOR_GAME = 'SET_LOADING_DATA_FOR_GAME';
export const SET_HIDE_PRIZE = 'SET_HIDE_PRIZE';

export const CLEAR_STATE = 'CLEAR_STATE';
export const CLEAR_ERROR = 'CLEAR_ERROR';

export const SET_LOADING_DATA_FOR_HEADER = 'SET_LOADING_DATA_FOR_HEADER';

export const SET_PAGE_FULLY_LOADED = 'SET_PAGE_FULLY_LOADED';
